import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Renders an upper right arrow
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 */
const defaultProps = {
    viewBoxSize: 48
}

const RightUpperArrowIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M 12.90,2.28
           C 12.90,2.28 48.54,2.34 48.54,2.34M 45.48,35.94
           C 45.48,35.94 45.73,0.30 45.73,0.30M 0.86,46.77
           C 0.86,46.77 47.08,2.18 47.08,2.18`}
        />
    </SvgIcon>
)

RightUpperArrowIcon.defaultProps = defaultProps

export { RightUpperArrowIcon }
